<template><IndustrialPropertyFormEditor form-name="newIndustrialPropertyForm" /></template>
<script>
import IndustrialPropertyFormEditor from "./IndustrialPropertyFormEditor.vue";
export default { name: "NewIndustrialPropertyForm", components: { IndustrialPropertyFormEditor } };
</script>
